export default __webpack_public_path__ + "static/media/boost-02@2x.ff4b81f8.webp";